import { render, staticRenderFns } from "./BarraPesquisa.vue?vue&type=template&id=258dc5a8&scoped=true"
import script from "./BarraPesquisa.vue?vue&type=script&lang=js"
export * from "./BarraPesquisa.vue?vue&type=script&lang=js"
import style0 from "./BarraPesquisa.vue?vue&type=style&index=0&id=258dc5a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258dc5a8",
  null
  
)

export default component.exports